import React, { Component } from 'react';
import AusstellungenDetails from '../components/AusstellungenDetails'; 
import Sidebar from '../components/Sidebar'; 
import Bestellen from '../components/Bestellen'; 

class AusstellungenDetailsContainer extends Component {
  constructor(props) {
		super(props);
		this.state = { 
		  bestellen:'',
		  bestellenName:'',
		  bestellenPrice:''
		}
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}
	handleOpen(name,price){
		this.setState({
			bestellen:'open',
			bestellenName:name,
			bestellenPrice:price
		});
		document.body.classList.toggle('no-scroll');
	}
	handleClose(data){
		this.setState({
			bestellen:''
		});
		document.body.classList.toggle('no-scroll');
	}
  componentDidMount(){	 
	setTimeout(function(){
		document.getElementById('submenu-ausstellungen').classList.add('active');
		document.getElementById('menu-programm').classList.add('active');
	},400);
  }
  componentWillUnmount(){
	document.getElementById('submenu-ausstellungen').classList.remove('active');
	document.getElementById('menu-programm').classList.remove('active');
  }
  componentWillMount(){
	document.body.scrollTop = document.documentElement.scrollTop = 0;
  }		
  render() {
		   const {page,staticData} = this.props.resolves;
		   return (
                <div>
					<div className="container-fluid lg-side-padding">
						<div className="row">
							<AusstellungenDetails {...page} /> 
							<Sidebar staticData={staticData} handleClick={this.handleOpen} {...page} />
						</div>
					</div>
					<Bestellen staticData={staticData} name={this.state.bestellenName} price={this.state.bestellenPrice} handleClick={this.handleClose} status={this.state.bestellen} />
				</div>
            )
       
  }
}
export default AusstellungenDetailsContainer;


// WEBPACK FOOTER //
// ./src/containers/AusstellungenDetailsContainer.js